import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=0ddb3baa&"
import script from "./NavigationMenu.js?vue&type=script&lang=js&"
export * from "./NavigationMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports